import React, {Fragment, Suspense} from 'react';
import {Button, Layout, Spin} from 'antd';
import {connect} from 'react-redux';
import {initApp} from "../store/actions/bookings";
import {withRouter} from "react-router-dom";
import LayoutTitle from './LayoutTitle';
import TopNav from './TopNav';
import UpgradeRequired from "./UpgradeRequired";
import {bootstrapOwnerPortalApp} from "../store/actions/unitcontracts";
import UnitContractSelector from "./UnitContractSelector";

const {Content, Footer} = Layout;

// let responseInterceptor = false;
const OwnerInnerApp = React.lazy(() => import("./OwnerInnerApp"));


class OwnerPortal extends React.Component {

    retryContracts = () => {
        this.props.dispatch(initApp());
    };

    componentDidMount() {
        const {dispatch} = this.props;
        dispatch(bootstrapOwnerPortalApp());
    }

    render() {
        const {selectedUnitContractId} = this.props;
        if(selectedUnitContractId === false) {
            return null;
        }
        return <Suspense fallback={<Fragment/>}>

            <Layout className="rerum-app">
                {this.props.loading ?
                    <div style={{width: "200px"}}>

                    </div>
                    :
                    this.props.failed ?
                        <div style={{width: "200px"}}>

                        </div> :
                        <React.Fragment>
                            {this.props.upgradeRequired ?
                                <UpgradeRequired/>
                                : null}
                            <TopNav {...this.props} />
                        </React.Fragment>
                }
                <Layout>
                    {!this.props.loading ?
                        <UnitContractSelector/>
                        :
                        null
                    }

                    <Content>
                        {this.props.failed ?

                            <Fragment>
                                <div style={{textAlign: "center"}} className="m-t-50">
                                    Sorry we could not load your contracts, please try again.
                                </div>
                                <p/>
                                <div style={{textAlign: "center"}}>
                                    <Button type="primary" icon="redo" size='large' onClick={this.retryContracts}
                                            loading={this.props.loading}>Retry</Button>
                                </div>
                            </Fragment>
                            :

                            this.props.loading ?
                                <div className="app-init-spinner">
                                    <div style={{textAlign: 'center'}}>
                                        Loading your bookings...
                                    </div>
                                    <p/>
                                    <Spin size="large"/>
                                </div>
                                :
                                <div style={{padding: 6, minHeight: 360}}>
                                    <LayoutTitle/>
                                    <OwnerInnerApp />
                                </div>

                        }
                    </Content>
                    <Footer style={{textAlign: 'left'}}>
                        {(new Date().getFullYear())} &copy; res:harmonics | The Apartment Management Software Company
                    </Footer>
                </Layout>
            </Layout>
        </Suspense>
    }
}

const mapStateToProps = state => {
    return {
        portalType: state.global.portalType,
        selectedUnitContractId: state.unitcontracts.selectedUnitContractId
    };
};

export default withRouter(connect(mapStateToProps)(OwnerPortal));